import { Table } from '@shared/Table'
import React from 'react'
import { columns as defaultColumns } from '../../../../../constants/orderdetailhistory.columns'
import { useBusinessCardOrderDetailMutation } from '@app/store/reducers/salaryCards/businessCardOrder.api'
const OrderHistoryTable = () => {
  const [_, { data: detailInformationList, isSuccess }] =
    useBusinessCardOrderDetailMutation({ fixedCacheKey: 'businessCardOrderDetail' })

  const columns = defaultColumns()
  return (
    <>
      <Table
        tableKey="orderHistoryTable"
        bordered
        editColumns={columns}
        dataSource={
          isSuccess ? detailInformationList.orderSalaryCardHistories : []
        }
        pagination={false}
        size="small"
      />
    </>
  )
}

export default OrderHistoryTable
